import React from "react";

import Countdown from "Components/Countdown";
import moment from "moment";
import styled from "styled-components";
import { theme } from "Theme";
import Config from "Data";
import { IconContext } from "react-icons";
import { FaGlobe } from "react-icons/fa";
import { MdOndemandVideo, MdAccessTime } from "react-icons/md";
import { IconCXOsync } from "Components/Brands";
import { DateIcon } from "Components";
import LinkBox from "../../LinkBox";

const EventCard = styled((props) => <LinkBox {...props} />)`
  position: relative;
  width: 100%;
  border-radius: ${theme.borderRadius.ui};
  overflow: hidden;
  .passed-event {
    opacity: 0.6 !important;
  }
`;

const GeneralEventCard = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: ${theme.borderRadius.ui};
  overflow: hidden;
  .future-event {
  }
  .passed-event {
    opacity: 0.6 !important;
    &:before {
      filter: grayscale(1);
      opacity: 0.4 !important;
    }
  }
`;

const EventIcon = styled.span`
  position: absolute;
  width: 120px;
  height: 64px;
  svg {
    opacity: 0.6;
    width: 100;
    height: 100%;
    fill: currentColor;
    vertical-align: middle;
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`;

const EventBrand = styled.div`
  align-self: center;
  color: #fff;
  z-index: 999;
  font-size: 12px;
  padding: 8px 4px;
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  border-radius: ${theme.borderRadius.elements};
  border: 1px solid #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  text-align: center;
  height: 54px;
  flex-direction: column;
  .react-icons {
    margin: 0;
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`;

const ListContents = styled.div`
  align-items: center;
  width: 100%;
  display: grid;
  grid-template-columns: 56px 1fr 56px;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`;

const EventInfo = styled.div`
  width: auto;
  position: relative;
  display: flex;
  flex-flow: column;
  overflow: visible;
  align-items: center;
  justify-content: center;
  z-index: 10;
  height: 68px;

  .event-card-city {
    align-self: center;
    letter-spacing: 1px;
    font-weight: normal;
    font-size: 0.9rem;
    color: #fff;
    position: relative;
    z-index: 2;
    margin: 0;
    line-height: 18px;
    text-shadow: 0 0 12px rgba(0, 0, 0, 1);
    span {
      display: inline;
      font-weight: bold;
    }
  }

  .category-tag-list {
    font-size: 0.9rem;
    text-transform: uppercase;
    position: relative;
    display: inline-block;
    font-weight: bold;
    color: #fff;
    padding: 0 4px 0;
    text-shadow: 0 0 12px rgba(0, 0, 0, 1);
  }
  .category-panel-list {
    font-size: 0.9rem;
    position: relative;
    display: inline-block;
    font-weight: bold;
    color: #fff;
    padding: 0 4px 0;
  }

  @media (min-width: ${theme.breakpoints.s}) {
    .event-card-city {
      font-size: 1.1rem;
    }
    .category-tag-list {
      font-size: 1.1rem;
    }
  }
  @media (min-width: ${theme.breakpoints.m}) {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    text-align: center;
    overflow: visible;
    .event-card-city {
      letter-spacing: 1px;
      color: #fff;
      position: relative;
      z-index: 2;
    }
    .category-tag-list {
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`;

const EventLink = styled.div`
  min-height: 128px;
  border-radius: ${theme.borderRadius.ui};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  padding: 1rem 1rem;

  &:focus {
    outline: auto;
  }

  &.event-list-featured {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    min-height: ${(props) => (props.big ? "150px" : "128px")};
    position: relative;
    padding: 1rem 1rem;
    .event-list-featured {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`;

const BGImage = (image) => (
  <div
    style={{
      backgroundImage: `url(${image.src})`,
      backgroundPosition: `center`,
      width: "100%",
      height: "100%",
      // backgroundSize: "cover",
      position: "absolute",
      top: 0,
      zIndex: -3,
      left: 0,
      objectFit: "cover !important",
      // objectPosition: "0% 0% !important",
    }}
  ></div>
);

const DimCircle = () => (
  <div
    style={{
      background: "radial-gradient(rgba(0, 0, 0, 0.75),rgba(0, 0, 0, 0.5))",
      width: "100%",
      height: "100%",
      backgroundSize: "cover",
      position: "absolute",
      top: 0,
      zIndex: -3,
    }}
  ></div>
);

const StyledName = (brandName, eventName, eventType, eventTime, eventPanel) => {
  let regexSTR = ["", ""];
  if (eventName) {
    regexSTR = eventName.split(/ (.*)/);
  }
  let audience = eventName.match(/^.*(CIO|CISO|CMO|CFO|HR|CX|DevSec|DevOp |secureDevOps).*$/);
  let currentAudience = audience ? audience[1] : brandName;
  let brandType;

  // console.log(`=========================`);
  // console.log(`brandName: `, brandName);
  // console.log(`eventName: `, eventName);
  // console.log(`currentAudience: `, currentAudience);

  switch (currentAudience) {
    case "CIO":
      brandType = regexSTR[0].replace(currentAudience, "");
      if (brandType === "fintech") {
        return (
          <>
            <EventIcon>
              <IconCXOsync brand={brandName} />
            </EventIcon>
            <p className="event-card-city">
              {brandType}
              <span>{currentAudience}</span>
            </p>
            {regexSTR[1] && (
              <div>
                <span className={"category-tag-list"}>{regexSTR[1]}</span>
              </div>
            )}
          </>
        );
      } else {
        return (
          <>
            <EventIcon>
              <IconCXOsync brand={brandName} />
            </EventIcon>
            <p className="event-card-city">
              <span>{currentAudience}</span>
              {brandType}
            </p>
            {regexSTR[1] && (
              <div>
                <span className={"category-tag-list"}>{regexSTR[1]}</span>
              </div>
            )}
          </>
        );
      }

    case "CISO":
      brandType = regexSTR[0].replace(currentAudience, "");
      if (brandType === "fintech") {
        return (
          <>
            <EventIcon>
              <IconCXOsync brand={brandName} />
            </EventIcon>
            <p className="event-card-city">
              {brandType}
              <span>{currentAudience}</span>
            </p>
            {regexSTR[1] && (
              <div>
                <span className={"category-tag-list"}>{regexSTR[1]}</span>
              </div>
            )}
          </>
        );
      } else if (eventType === "webinar") {
        return (
          <>
            <EventIcon>
              <IconCXOsync brand={brandName} />
            </EventIcon>
            <p className="event-card-city">
              <span>{currentAudience}</span>
              {brandType}
            </p>
            {regexSTR[1] && (
              <div>
                <span className={"category-tag-list"}>{regexSTR[1]}</span>
              </div>
            )}
          </>
        );
      } else {
        return (
          <>
            <EventIcon>
              <IconCXOsync brand={brandName} />
            </EventIcon>
            <p className="event-card-city">
              {brandType}
              <span>{currentAudience}</span>
            </p>
            {regexSTR[1] && (
              <div>
                <span className={"category-tag-list"}>{regexSTR[1]}</span>
              </div>
            )}
          </>
        );
      }

    case "CMO":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "CFO":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "HR":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "CX":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "DevSec":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "secureDevOps":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "DevOp":
      brandType = regexSTR[0].replace(currentAudience, "");
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{currentAudience}</span>
            {brandType}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "DevState":
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={"brandName"} />
          </EventIcon>
          <p className="event-card-city">
            <span>{eventName}</span>
            {/* {brandType} */}
          </p>
          {regexSTR[1] && (
            <div>
              <span className={"category-tag-list"}>{regexSTR[1]}</span>
            </div>
          )}
        </>
      );

    case "CISOspotlight":
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{"CISO"}</span>
            spotlight
          </p>
          {eventName && (
            <div>
              <span className={"category-tag-list"}>{eventName}</span>
            </div>
          )}
        </>
      );

    case "CIOspotlight":
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{"CIO"}</span>
            spotlight
          </p>
          {eventName && (
            <div>
              <span className={"category-tag-list"}>{eventName}</span>
            </div>
          )}
        </>
      );

    case "CMOspotlight":
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{"CMO"}</span>
            spotlight
          </p>
          {eventName && (
            <div>
              <span className={"category-tag-list"}>{eventName}</span>
            </div>
          )}
        </>
      );

    case "CFOspotlight":
      return (
        <>
          <EventIcon>
            <IconCXOsync brand={brandName} />
          </EventIcon>
          <p className="event-card-city">
            <span>{"CFO"}</span>
            spotlight
          </p>
          {eventName && (
            <div>
              <span className={"category-tag-list"}>{eventName}</span>
            </div>
          )}
        </>
      );

    default:
      return "";
  }
};

class EventListInfo extends React.Component {
  render() {
    const {
      banner,
      big,
      brandName,
      eventName,
      countdown,
      eventDate,
      eventCity,
      eventRegion,
      eventCountryISO,
      eventType,
      eventTime,
      eventPanel,
      eventStart,
      eventURL,
      featured,
      track,
      teaser
    } = this.props;

    const activeURL = eventURL ? true : false;
    const eventDateTime = moment(eventDate);
    let spotlight = brandName.match(/^.*(spotlight).*$/);
    // const countdown = eventDateTime.isBefore(moment(), "day")
    // var eventRoot;
    // if (eventDateTime.isBefore(moment(), 'day')) {
    //   const eventDomainRegex = new RegExp(
    //     `^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)`
    //   );
    //   eventRoot = eventDomainRegex.exec(eventURL)[0];
    // } else {
    //   eventRoot = 'Future Event';
    // }

    // let regexSTR = brandName.split(" ")

    // let regexSTR = ["", ""]
    // if (eventName) {
    //   regexSTR = eventName.split(/ (.*)/)
    // }
    // let audience = "CISO"
    // let brandType = regexSTR[0].replace(audience, "")

    return (
      <>
        {/* Today or future Events */}
        {activeURL && !teaser && !eventDateTime.isBefore(moment(), "day") && (
          <EventCard
            to={`${eventURL}`}
            title={`${Config.brand} ${eventCity} | ${eventDateTime.format("YYYY")}-${eventDateTime.format("MM")}-${eventDateTime.format("DD")}`}
            target="_blank"
            className={activeURL}
            track={track}
          >
            <div>
              <EventLink big={big} Tag="section" className={`${!eventDateTime.isBefore(moment(), "day") ? "future-event" : "passed-event"}`}>
                <BGImage src={spotlight ? "https://cdn.cxosync.com/images/cities/location-placeholder.jpg" : banner} />
                <DimCircle />
                <ListContents big={big} className={`${featured ? "countdown" : ""}`}>
                  {teaser && <div></div>}
                  {!teaser && (
                    <div>
                      <DateIcon date={eventDate} />
                    </div>
                  )}
                  <EventInfo>
                    {/* <img
                    src={`${Config.cdn}/images/flags/${eventCountryISO}.png`}
                    title={`${eventCountryISO} Flag`}
                    alt={`${eventCountryISO} Flag`}
                    style={{width:24}}
                  />{" "} */}
                    {StyledName(brandName, eventName, eventType, eventTime, eventPanel)}
                  </EventInfo>
                  {teaser && <div></div>}
                  {!teaser && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )}
                  {eventType === "webinar" && (
                    <div>
                      <div className="panel-box" title={`${eventPanel ? eventPanel + " " : ""}Webinar`}>
                        <IconContext.Provider value={{ className: "play-btn-icon" }}>
                          <MdOndemandVideo />
                        </IconContext.Provider>{" "}
                        <small>{eventPanel !== "NA" ? eventPanel : ""}</small>
                      </div>
                      {eventTime && (
                        <div className="time-box" title={`${eventTime ? eventTime : ""}`}>
                          <div>
                            <IconContext.Provider value={{ className: "play-btn-icon" }}>
                              <MdAccessTime />
                            </IconContext.Provider>{" "}
                            <small>{eventTime && eventTime}</small>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {countdown && <Countdown className="event-list-countdown" toDate={`${eventDate} ${eventStart}`} timeFormat="YYYY-MM-DD hh:mm" />}
                  {/* {eventType === "conference" && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )} */}
                </ListContents>
              </EventLink>
            </div>
          </EventCard>
        )}

        {/* Passed Events */}
        {activeURL && !teaser && eventDateTime.isBefore(moment(), "day") && (
          <EventCard
            to={`${eventURL}`}
            title={`${Config.brand} ${eventCity} | ${eventDateTime.format("YYYY")}-${eventDateTime.format("MM")}-${eventDateTime.format("DD")}`}
            target="_blank"
            track={track}
          >
            <div>
              <EventLink big={big} Tag="section" className={`${!eventDateTime.isBefore(moment(), "day") ? "future-event" : "passed-event"}`}>
                <BGImage src={spotlight ? "https://cdn.cxosync.com/images/cities/location-placeholder.jpg" : banner} />
                <DimCircle />
                <ListContents big={big} className={`${featured ? "countdown" : ""}`}>
                  <div>
                    <DateIcon date={eventDate} />
                  </div>
                  <EventInfo>
                    {/* <img
                    src={`${Config.cdn}/images/flags/${eventCountryISO}.png`}
                    title={`${eventCountryISO} Flag`}
                    alt={`${eventCountryISO} Flag`}
                    style={{width:24}}
                  />{" "} */}
                    {StyledName(brandName, eventName, eventType, eventTime, eventPanel)}
                  </EventInfo>
                  {eventType === "webinar" && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )}
                  {eventType === "webinar" && (
                    <div>
                      <div className="panel-box" title={`${eventPanel ? eventPanel + " " : ""}Webinar`}>
                        <IconContext.Provider value={{ className: "play-btn-icon" }}>
                          <MdOndemandVideo />
                        </IconContext.Provider>{" "}
                        <small>{eventPanel !== "NA" ? eventPanel : ""}</small>
                      </div>
                      {eventTime && (
                        <div className="time-box" title={`${eventTime ? eventTime : ""}`}>
                          <div>
                            <IconContext.Provider value={{ className: "play-btn-icon" }}>
                              <MdAccessTime />
                            </IconContext.Provider>{" "}
                            <small>{eventTime && eventTime}</small>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {countdown && <Countdown className="event-list-countdown" toDate={`${eventDate} ${eventStart}`} timeFormat="YYYY-MM-DD hh:mm" />}
                  {eventType === "conference" && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )}
                </ListContents>
              </EventLink>
            </div>
          </EventCard>
        )}

        {/* NO URL */}
        {!activeURL && !teaser && (
          <GeneralEventCard>
            <EventLink big={big} Tag="section" className={`${!eventDateTime.isBefore(moment(), "day") ? "future-event" : "passed-event"}`}>
              <BGImage src={spotlight ? "https://cdn.cxosync.com/images/cities/location-placeholder.jpg" : banner} />
              <DimCircle />
              <ListContents big={big} className={`${featured ? "countdown" : ""}`}>
                <div>
                  <DateIcon date={eventDate} />
                </div>
                <EventInfo>
                  {/* <img
                    src={`${Config.cdn}/images/flags/${eventCountryISO}.png`}
                    title={`${eventCountryISO} Flag`}
                    alt={`${eventCountryISO} Flag`}
                    style={{width:24}}
                  />{" "} */}
                  {StyledName(brandName, eventName, eventType, eventTime, eventPanel)}
                </EventInfo>
                {eventType === "webinar" && (
                  <div>
                    <div className="panel-box" title={`${eventPanel ? eventPanel + " " : ""}Webinar`}>
                      <IconContext.Provider value={{ className: "play-btn-icon" }}>
                        <MdOndemandVideo />
                      </IconContext.Provider>{" "}
                      <small>{eventPanel !== "NA" ? eventPanel : ""}</small>
                    </div>
                    {eventTime && (
                      <div className="time-box" title={`${eventTime ? eventTime : ""}`}>
                        <div>
                          <IconContext.Provider value={{ className: "play-btn-icon" }}>
                            <MdAccessTime />
                          </IconContext.Provider>{" "}
                          <small>{eventTime && eventTime}</small>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {countdown && <Countdown className="event-list-countdown" toDate={`${eventDate} ${eventStart}`} timeFormat="YYYY-MM-DD hh:mm" />}
                {/* {eventType === "conference" && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )} */}
              </ListContents>
            </EventLink>
          </GeneralEventCard>
        )}

        {/* Next Year Events */}
        {activeURL && teaser && (
          <GeneralEventCard
            // to={`#`}
            title={`${Config.brand} ${eventCity} | ${eventDateTime.format("YYYY")}-${eventDateTime.format("MM")}-${eventDateTime.format("DD")}`}
            target="_blank"
            className={activeURL}
            track={track}
          >
            <div>
              <EventLink big={big} Tag="section" className={`future-event`}>
                <BGImage src={spotlight ? "https://cdn.cxosync.com/images/cities/location-placeholder.jpg" : banner} />
                <DimCircle />
                <ListContents big={big} className={`${featured ? "countdown" : ""}`}>
                  {teaser && <div></div>}
                  {!teaser && (
                    <div>
                      <DateIcon date={eventDate} />
                    </div>
                  )}
                  <EventInfo>
                    {/* <img
                    src={`${Config.cdn}/images/flags/${eventCountryISO}.png`}
                    title={`${eventCountryISO} Flag`}
                    alt={`${eventCountryISO} Flag`}
                    style={{width:24}}
                  />{" "} */}
                    {StyledName(brandName, eventName, eventType, eventTime, eventPanel)}
                  </EventInfo>
                  {teaser && <div></div>}
                  {!teaser && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )}
                  {eventType === "webinar" && (
                    <div>
                      <div className="panel-box" title={`${eventPanel ? eventPanel + " " : ""}Webinar`}>
                        <IconContext.Provider value={{ className: "play-btn-icon" }}>
                          <MdOndemandVideo />
                        </IconContext.Provider>{" "}
                        <small>{eventPanel !== "NA" ? eventPanel : ""}</small>
                      </div>
                      {eventTime && (
                        <div className="time-box" title={`${eventTime ? eventTime : ""}`}>
                          <div>
                            <IconContext.Provider value={{ className: "play-btn-icon" }}>
                              <MdAccessTime />
                            </IconContext.Provider>{" "}
                            <small>{eventTime && eventTime}</small>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {countdown && <Countdown className="event-list-countdown" toDate={`${eventDate} ${eventStart}`} timeFormat="YYYY-MM-DD hh:mm" />}
                  {/* {eventType === "conference" && (
                    <EventBrand target="_blank">
                      <IconContext.Provider value={{ className: "react-icons" }}>
                        <FaGlobe />
                      </IconContext.Provider>
                      <span>Visit</span>
                    </EventBrand>
                  )} */}
                </ListContents>
              </EventLink>
            </div>
          </GeneralEventCard>
        )}
      </>
    );
  }
}

export default EventListInfo;
